import React from 'react';
import { useTheme } from '../../contexts/ThemeContext';

interface FormFieldProps {
  label: string;
  children: React.ReactNode;
  error?: string;
  required?: boolean;
}

export default function FormField({ label, children, error, required }: FormFieldProps) {
  const { theme } = useTheme();

  return (
    <div>
      <label className={`block text-sm font-medium mb-2 ${
        theme === 'dark' ? 'text-gray-200' : 'text-gray-700'
      }`}>
        {label}
        {required && <span className="text-red-500 ml-1">*</span>}
      </label>
      {children}
      {error && (
        <p className="mt-1 text-sm text-red-500">{error}</p>
      )}
    </div>
  );
}